import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-[#1B2E50] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-display font-semibold text-4xl md:text-5xl tracking-tighter leading-none">
            Quality lets in Hull.
            <br />
            <span className="text-[#C99B5A]">Designed for living.</span>
          </div>
          <p className="mt-6 text-white/70 max-w-md">
            Independent landlord. Three carefully chosen properties for professionals and students in
            Hull's most liveable neighbourhoods.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="label-uppercase !text-[#C99B5A] mb-4">Explore</div>
          <ul className="space-y-3 text-white/80">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/properties" className="hover:text-white">Properties</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="label-uppercase !text-[#C99B5A] mb-4">Get in touch</div>
          <ul className="space-y-3 text-white/80">
            <li>
              <a href="mailto:ampmpropertyinvestments@gmail.com" className="hover:text-white" data-testid="footer-email-link">
                ampmpropertyinvestments@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:+447365813254" className="hover:text-white" data-testid="footer-phone-link">
                07365 813254
              </a>
            </li>
            <li>Hull, East Yorkshire, UK</li>
          </ul>
        </div>
      </div>
    </footer>
  );
};
